import { FileText, Heart, MonitorDot, Settings, ShoppingBag, ShoppingCart, Undo2, UserRound, LayoutDashboard } from "lucide-react";

const menuData: any = [
  // {
  //     label: 'menu',
  //     isTitle: true,
  // },
  {
    id: "dashboard",
    label: 'Dashboard',
    link: "/dashboard",
    icon: <MonitorDot />,
  },
  {
    id: "desk-view-dashboard",
    label: 'Desk View Dashboard',
    link: "/desk-view-dashboard",
    icon: <LayoutDashboard />,
  },
  {
    id: 'orders',
    label: 'Orders',
    link: '/orders',
    icon: <FileText />,
  },
  {
    id: 'pos',
    label: 'POS',
    link: '/pos',
    icon: <FileText />,
  },
  {
    id: 'pos-new',
    label: 'POS New',
    link: '/pos-new',
    icon: <FileText />,
  },

  {
    id: 'business-list',
    label: 'Businesses',
    icon: <UserRound />,
    link: '/business-list',
  },

  {
    id: 'carts',
    label: 'Carts',
    link: '/carts',
    icon: <ShoppingCart />,
  },

  {
    id: 'wishlists',
    label: 'Wishlist',
    link: '/wishlist',
    icon: <Heart />,
  },
  {
    id: "catalog",
    label: 'Catalog',
    link: "/#",
    icon: <ShoppingBag />,
    subItems: [

      {
        id: 'brands',
        label: 'Brands',
        link: '/brands-list',
        parentId: 'catalog',
      },
      {
        id: 'categories',
        label: 'Categories',
        parentId: 'catalog',
        link: '/category-list',
      },

      {
        id: 'products',
        label: 'Products',
        link: '/product-list',
        parentId: 'catalog',
      },

      {
        id: 'attributes',
        label: 'Product Attributes',
        link: '/attribute-list',
        parentId: 'catalog'
      },
      {
        id: 'attributevalue',
        label: 'Product Atttribute Values',
        link: '/attribute-value-list',
        parentId: 'catalog'
      },
      {
        id: 'productsizes',
        label: 'Product Sizes',
        link: '/product-size-list',
        parentId: 'catalog'
      },
      // {
      //   id: 'productcolors',
      //   label: 'Product Color',
      //   link: '/product-color-list',
      //   parentId: 'catalog'
      // },
      {
        id: 'BulkUploadProduct',
        label: 'Product Upload',
        link: '/bulk-upload-product',
        parentId: 'catalog',
      },
      {
        id: 'BulkUploadProductImages',
        label: 'Product Images Upload',
        link: '/bulk-upload-product-images',
        parentId: 'catalog',
      },
      {
        id: 'BarcodeGenerator',
        label: 'Barcode Generator',
        link: '/barcode-generator',
        parentId: 'catalog',
      },
    ]
  },

  {
    id: 'master-data',
    label: 'Master Data',
    icon: <FileText />,
    parentId: 2,
    subItems: [
      {
        id: 'coupons',
        label: 'Coupons',
        link: '/coupon-list',
        parentId: 'contentmanagement'
      },
      {
        id: 'banners',
        label: 'Banners',
        link: '/banner-list',
        parentId: 'contentmanagement'
      },
      {
        id: 'cms',
        label: 'CMS',
        link: '/cms-list',
        parentId: 'contentmanagement'
      }
      ,

      {
        id: 'announcements',
        label: 'Notifications',
        link: '/announcement-list',
        parentId: 'contentmanagement'
      },
      {
        id: 'faqs',
        label: 'FAQs',
        link: '/faq-list',
        parentId: 'contentmanagement'
      },
    ]
  },


  {
    id: 'report-management',
    label: 'Reports',
    icon: <UserRound />,
    parentId: 2,
    subItems: [

      {
        id: 'OrdersBySalesRep',
        label: 'Orders By Sales Rep',
        link: '/orders-by-sales-rep',
        parentId: 'report-management'
      },
      {
        id: 'sales-summary',
        label: 'Sales Summary',
        link: '/coming-soon',
        parentId: 'report-management'
      },
      {
        id: 'low-inventory',
        label: 'Low Inventory',
        link: '/coming-soon',
        parentId: 'report-management'
      },
      {
        id: 'best-seller',
        label: 'Best Seller',
        link: '/coming-soon',
        parentId: 'report-management'
      }
      ,
      {
        id: 'product-never-sold',
        label: 'Product Never Sold',
        link: '/coming-soon',
        parentId: 'report-management'
      }
      ,
      // {
      //   id: 'customer-order',
      //   label: 'Customer Order',
      //   link: '/coming-soon',
      //   parentId: 'report-management'
      // },
      // {
      //   id: 'user-product-history',
      //   label: 'User Search History',
      //   link: '/coming-soon',
      //   parentId: 'report-management'
      // }
      {
        id: 'track-activity',
        label: 'Track Activity',
        link: '/coming-soon',
        parentId: 'customer-management'
      }
    ]
  },
  {
    id: 'application-configuration',
    label: 'Application Settings',
    icon: <Settings />,
    parentId: 2,
    subItems: [
      {
        id: 'manage-company',
        label: 'Manage Company',
        link: '/manage-company',
        parentId: 'configuration'
      },
      {
        id: 'manage-gsrate',
        label: 'GST Rate',
        link: '/gstrates',
        parentId: 'configuration'
      },
      {
        id: 'common-settings',
        label: 'Common Settings',
        link: '/coming-soon',
        parentId: 'configuration'
      }, {
        id: 'email-settings',
        label: 'Email Settings',
        link: '/coming-soon',
        parentId: 'configuration'
      },
      // {
      //     id: 'season',
      //     label: 'Manage Season',
      //     link: '/season-list',
      //     parentId: 'configuration'
      // }
      // ,
      {
        id: 'districts',
        label: 'Districts',
        link: '/district-list',
        parentId: 'configuration'
      },
      {
        id: 'cities',
        label: 'Cities',
        link: '/city-list',
        parentId: 'configuration'
      },
      {
        id: 'users',
        label: 'Users',
        link: '/userlist',
        parentId: 'configuration'
      },
      {
        id: 'settings',
        label: 'Settings',
        link: '/setting-list',
        parentId: 'configuration'
      },
      {
        id: 'SyncERP',
        label: 'Sync ERP',
        link: '/sync-erp',
        parentId: 'configuration'
      },
      // {
      //   id: 'sales-rep-business-mapping',
      //   label: 'Sales Rep Business Mapping',
      //   link: '/sales-rep-business-mapping',
      //   parentId: 'configuration'
      // }
    ]
  },
  {
    id: 'system-configuration',
    label: 'System Settings',
    icon: <Settings />,
    parentId: 2,
    subItems: [
      {
        id: 'menu-management',
        label: 'Menu Management',
        link: '/menu-management',
        parentId: 'configuration'
      },
      {
        id: 'role-menu-management',
        label: 'Role Menu Management',
        link: '/role-menu-management',
        parentId: 'configuration'
      },
      {
        id: 'roles',
        label: 'Roles',
        link: '/roles',
        parentId: 'configuration'
      },
      {
        id: 'resources',
        label: 'Resources',
        link: '/resources',
        parentId: 'configuration'
      },
      {
        id: 'permissions',
        label: 'Permissions',
        link: '/permissions',
        parentId: 'configuration'
      }
    ]
  },

];



export const UserPermissions: any = [
  {
    resource: "brands"
  },
  {
    resource: "productimages"
  },
  {
    resource: "faqs"
  },
  {
    resource: "users"
  },
  {
    resource: "seasons"
  },
  {
    resource: "categories"
  },
  {
    resource: "businessaddresses"
  },
  {
    resource: "wishlists"
  },
  {
    resource: "orderheaders"
  },
  {
    resource: "ordertrackings"
  },
  {
    resource: "shippingaddresses"
  },
  {
    resource: "billingaddresses"
  },
  {
    resource: "coupons"
  },
  {
    resource: "orders"
  },
  {
    resource: "businesses"
  },
  {
    resource: "banners"
  },
  {
    resource: "attributevalues"
  },
  {
    resource: "attributes"
  },
  {
    resource: "products"
  },
  {
    resource: "cms"
  },
  {
    resource: "productcolors"
  },
  {
    resource: "carts"
  },
  {
    resource: "productpackagings"
  },
  {
    resource: "orderlines"
  },
  {
    resource: "productsizes"
  },
  {
    resource: "productvariants"
  },
  {
    resource: "announcements"
  },
  {
    resource: "businesscoupons"
  }
]

export { menuData };